import axios from 'axios';
import { baseUrl } from '../hooks/useEndpoints';
import {
  ICoachTeam,
  IIndividualAthlete,
  IManualEntryPreferences,
  IReassignTeamPayload,
  IUpsertManualPreferencesPayload,
  ManualEntryScopeType,
} from '../models/m6-2';

/**
 * Endpoint M6.2.
 * Auth + entity-id gestiti da axios interceptor globale (useEndpoints).
 */
export const m6_2Endpoints = {
  /** GET /teams/me · team dove user è coach/director */
  getMyTeams: () => axios.get<ICoachTeam[]>(`${baseUrl}/teams/me`),

  /** GET /sessions/athletes/individual · atleti individuali del coach */
  getIndividualAthletes: () =>
    axios.get<IIndividualAthlete[]>(
      `${baseUrl}/sessions/athletes/individual`,
    ),

  /** GET /sessions/athlete/:id?scope= · sessioni filtered */
  getAthleteSessions: (
    athleteId: string,
    params: {
      scope?: 'all' | 'team' | 'individual';
      from?: string;
      to?: string;
    },
  ) =>
    axios.get(`${baseUrl}/sessions/athlete/${athleteId}`, {
      params,
    }),

  /** PUT /sessions/:id/reassign-team · riassegna sessione a nuovo team */
  reassignSessionTeam: (sessionId: string, payload: IReassignTeamPayload) =>
    axios.put(`${baseUrl}/sessions/${sessionId}/reassign-team`, payload),

  /** GET /manual-entry-preferences?scopeType=&scopeId= · preferenze con fallback */
  getManualEntryPreferences: (
    scopeType: ManualEntryScopeType,
    scopeId: string,
  ) =>
    axios.get<IManualEntryPreferences | null>(
      `${baseUrl}/manual-entry-preferences`,
      { params: { scopeType, scopeId } },
    ),

  /** PUT /manual-entry-preferences · upsert */
  upsertManualEntryPreferences: (payload: IUpsertManualPreferencesPayload) =>
    axios.put<IManualEntryPreferences>(
      `${baseUrl}/manual-entry-preferences`,
      payload,
    ),

  /** GET /manual-entry-preferences/mine · tutti i record del coach */
  getMyManualEntryPreferences: () =>
    axios.get<IManualEntryPreferences[]>(
      `${baseUrl}/manual-entry-preferences/mine`,
    ),

  /** DELETE /manual-entry-preferences/:id · elimina preferenza */
  deleteManualEntryPreferences: (id: string) =>
    axios.delete<{ success: boolean }>(
      `${baseUrl}/manual-entry-preferences/${id}`,
    ),
};
